import { create } from 'zustand';

const useSmenaStore = create((set) => ({
    smenaId: null,
    setSmenaId: (id) => set({ smenaId: id }),
    clearSmenaId: () => set({ smenaId: null }),
}));

export default useSmenaStore;
